// import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
// import axios from 'axios';
//
// const initialState = {
//     orderData: {
//         materialSqft: null,
//         hardwareQuantity: null,
//         sppData: null,
//         drawerData: null,
//         drawerFronts: [],
//         doorDimensions: [],
//         blindFronts: [],
//         prfData: [],
//         orderInfo: null
//     },
//     status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
//     error: null,
//     lastFetchedOrder: null
// };
//
// export const fetchOrderSummary = createAsyncThunk(
//     'order/fetchOrderSummary',
//     async ({orderId, token, baseURL}, {rejectWithValue}) => {
//         try {
//             const config = {headers: {'Authorization': `Bearer ${token}`}};
//             const response = await axios.post(
//                 `${baseURL}/user/customer-portal/${orderId}/getOrderSummary`,
//                 null,
//                 config
//             );
//
//             const roundedMaterialSqft = Object.fromEntries(
//                 Object.entries(response.data.materialSqft)
//                     .map(([matId, sqft]) => [matId, parseFloat(sqft.toFixed(2))])
//             );
//
//             return {
//                 materialSqft: roundedMaterialSqft,
//                 hardwareQuantity: response.data.hardwareQuantity,
//                 sppData: response.data.spp,
//                 drawerData: response.data.drawers,
//                 drawerFronts: response.data.drawerFronts,
//                 doorDimensions: response.data.doorDimensions,
//                 blindFronts: response.data.blindFronts,
//                 prfData: response.data.prfFt,
//                 numOfCabinets: response.data.numOfCabinets,
//                 orderInfo: response.data.orderInfo,
//             };
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     },
//     {
//         // Only fetch if we haven't fetched this order before or if it's been more than 5 minutes
//         condition: ({orderId}, {getState}) => {
//             const {order} = getState();
//             if (order.status === 'loading') return false;
//             if (order.lastFetchedOrder?.id === orderId) {
//                 const timeSinceLastFetch = Date.now() - order.lastFetchedOrder.timestamp;
//                 if (timeSinceLastFetch < 300000) return false; // 5 minutes in milliseconds
//             }
//             return true;
//         }
//     }
// );
//
// const orderSlice = createSlice({
//     name: 'order',
//     initialState,
//     reducers: {
//         clearOrderData: (state) => {
//             state.orderData = initialState.orderData;
//             state.status = 'idle';
//             state.error = null;
//             state.lastFetchedOrder = null;
//         }
//     },
//     extraReducers: (builder) => {
//         builder
//             .addCase(fetchOrderSummary.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(fetchOrderSummary.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.orderData = action.payload;
//                 state.lastFetchedOrder = {
//                     id: action.meta.arg.orderId,
//                     timestamp: Date.now()
//                 };
//             })
//             .addCase(fetchOrderSummary.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             });
//     }
// });
//
// export const {clearOrderData} = orderSlice.actions;
// export default orderSlice.reducer;


import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {logOut} from '../user/userSlice'
import axios from 'axios';

const initialState = {
    orderData: {
        materialSqft: null,
        hardwareQuantity: null,
        sppData: null,
        drawerData: null,
        drawerFronts: [],
        doorDimensions: [],
        blindFronts: [],
        prfData: [],
        orderInfo: null
    },
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    lastFetchedOrder: null,

    // New state for past orders
    pastOrders: [],
    pastOrdersStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    pastOrdersError: null,
    lastFetchedEmail: null,

    // New state for order articles (edit order data)
    orderArticles: [],
    orderArticlesStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    orderArticlesError: null,
    lastFetchedArticles: null,

    // New state for all orders (internal/admin)
    allOrders: [],
    allOrdersStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    allOrdersError: null,
    lastFetchedAllOrders: null
};

export const fetchOrderSummary = createAsyncThunk(
    'order/fetchOrderSummary',
    async ({orderId, token, baseURL}, {rejectWithValue}) => {
        try {
            const config = {headers: {'Authorization': `Bearer ${token}`}};
            const response = await axios.post(
                `${baseURL}/user/customer-portal/${orderId}/getOrderSummary`,
                null,
                config
            );

            const roundedMaterialSqft = Object.fromEntries(
                Object.entries(response.data.materialSqft)
                    .map(([matId, sqft]) => [matId, parseFloat(sqft.toFixed(2))])
            );

            return {
                materialSqft: roundedMaterialSqft,
                hardwareQuantity: response.data.hardwareQuantity,
                sppData: response.data.spp,
                drawerData: response.data.drawers,
                drawerFronts: response.data.drawerFronts,
                doorDimensions: response.data.doorDimensions,
                blindFronts: response.data.blindFronts,
                prfData: response.data.prfFt,
                numOfCabinets: response.data.numOfCabinets,
                orderInfo: response.data.orderInfo,
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
    // {
    //     // Only fetch if we haven't fetched this order before or if it's been more than 5 minutes
    //     condition: ({orderId}, {getState}) => {
    //         const {order} = getState();
    //         if (order.status === 'loading') return false;
    //         if (order.lastFetchedOrder?.id === orderId) {
    //             const timeSinceLastFetch = Date.now() - order.lastFetchedOrder.timestamp;
    //             if (timeSinceLastFetch < 300000) return false; // 5 minutes in milliseconds
    //         }
    //         return true;
    //     }
    // }
);

export const fetchAllOrders = createAsyncThunk(
    'order/fetchAllOrders',
    async ({token, baseURL}, {rejectWithValue}) => {
        try {
            const response = await axios.get(
                `${baseURL}/api/internal/findAllOrders`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching all orders:', error);
            return rejectWithValue(error.message);
        }
    },
    // {
    //     // Only fetch if we haven't fetched all orders recently
    //     condition: (_, {getState}) => {
    //         const {order} = getState();
    //         if (order.allOrdersStatus === 'loading') return false;
    //         if (order.lastFetchedAllOrders) {
    //             const timeSinceLastFetch = Date.now() - order.lastFetchedAllOrders.timestamp;
    //             if (timeSinceLastFetch < 300000) return false; // 5 minutes in milliseconds
    //         }
    //         return true;
    //     }
    // }
);

export const fetchArticlesByOrderId = createAsyncThunk(
    'order/fetchArticlesByOrderId',
    async ({orderId, token, baseURL}, {rejectWithValue}) => {
        try {
            const response = await axios.get(
                `${baseURL}/user/customer-portal/${orderId}/edit-order`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching articles by order ID:', error);
            return rejectWithValue(error.message);
        }
    },
    // {
    //     // Only fetch if we haven't fetched articles for this order recently
    //     condition: ({orderId}, {getState}) => {
    //         const {order} = getState();
    //         if (order.orderArticlesStatus === 'loading') return false;
    //         if (order.lastFetchedArticles?.orderId === orderId) {
    //             const timeSinceLastFetch = Date.now() - order.lastFetchedArticles.timestamp;
    //             if (timeSinceLastFetch < 300000) return false; // 5 minutes in milliseconds
    //         }
    //         return true;
    //     }
    // }
);

export const fetchAllPastOrdersByEmail = createAsyncThunk(
    'order/fetchAllPastOrdersByEmail',
    async ({email, token, baseURL}, {rejectWithValue}) => {
        try {
            const response = await axios.post(
                `${baseURL}/user/customer-portal/getAllOrders`,
                {email: email},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
    // {
    //     // Only fetch if we haven't fetched orders for this email recently
    //     condition: ({email}, {getState}) => {
    //         const {order} = getState();
    //         if (order.pastOrdersStatus === 'loading') return false;
    //         if (order.lastFetchedEmail?.email === email) {
    //             const timeSinceLastFetch = Date.now() - order.lastFetchedEmail.timestamp;
    //             if (timeSinceLastFetch < 300000) return false; // 5 minutes in milliseconds
    //         }
    //         return true;
    //     }
    // }
);

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        addOrder: (state, action) => {
            state.pastOrders.unshift(action.payload);
        },

        clearOrderData: (state) => {
            state.orderData = initialState.orderData;
            state.status = 'idle';
            state.error = null;
            state.lastFetchedOrder = null;
        },
        clearPastOrders: (state) => {
            state.pastOrders = [];
            state.pastOrdersStatus = 'idle';
            state.pastOrdersError = null;
            state.lastFetchedEmail = null;
        },
        clearOrderArticles: (state) => {
            state.orderArticles = [];
            state.orderArticlesStatus = 'idle';
            state.orderArticlesError = null;
            state.lastFetchedArticles = null;
        },
        clearAllOrders: (state) => {
            state.allOrders = [];
            state.allOrdersStatus = 'idle';
            state.allOrdersError = null;
            state.lastFetchedAllOrders = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrderSummary.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOrderSummary.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.orderData = action.payload;
                state.lastFetchedOrder = {
                    id: action.meta.arg.orderId,
                    timestamp: Date.now()
                };
            })
            .addCase(fetchOrderSummary.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            // Past orders cases
            .addCase(fetchAllPastOrdersByEmail.pending, (state) => {
                state.pastOrdersStatus = 'loading';
            })
            .addCase(fetchAllPastOrdersByEmail.fulfilled, (state, action) => {
                state.pastOrdersStatus = 'succeeded';
                state.pastOrders = action.payload;
                state.lastFetchedEmail = {
                    email: action.meta.arg.email,
                    timestamp: Date.now()
                };
            })
            .addCase(logOut, (state) => {
                return initialState; // Reset to initial state
            })
            .addCase(fetchAllPastOrdersByEmail.rejected, (state, action) => {
                state.pastOrdersStatus = 'failed';
                state.pastOrdersError = action.payload;
            })
            // Order articles cases
            .addCase(fetchArticlesByOrderId.pending, (state) => {
                state.orderArticlesStatus = 'loading';
            })
            .addCase(fetchArticlesByOrderId.fulfilled, (state, action) => {
                state.orderArticlesStatus = 'succeeded';
                state.orderArticles = action.payload;
                state.lastFetchedArticles = {
                    orderId: action.meta.arg.orderId,
                    timestamp: Date.now()
                };
            })
            .addCase(fetchArticlesByOrderId.rejected, (state, action) => {
                state.orderArticlesStatus = 'failed';
                state.orderArticlesError = action.payload;
            })
            // All orders cases
            .addCase(fetchAllOrders.pending, (state) => {
                state.allOrdersStatus = 'loading';
            })
            .addCase(fetchAllOrders.fulfilled, (state, action) => {
                state.allOrdersStatus = 'succeeded';
                state.allOrders = action.payload;
                state.lastFetchedAllOrders = {
                    timestamp: Date.now()
                };
            })
            .addCase(fetchAllOrders.rejected, (state, action) => {
                state.allOrdersStatus = 'failed';
                state.allOrdersError = action.payload;
            });
    }
});

export const {addOrder, clearOrderData, clearPastOrders, clearOrderArticles, clearAllOrders} = orderSlice.actions;
export default orderSlice.reducer;